import getFileDownloadUrl from '../../utils/getFileDownloadUrl';
import { getFileTypeFromExtension } from '../../utils/fileExtensionManager';
import {
    FileExtensionTypes,
    SharePointFileInformation,
    SharePointFileViewState,
    SharePointFilePreviewMethod,
} from 'owa-group-files-hub-store';

export default function prepareSharePointFileViewState(
    fileInformation: SharePointFileInformation
): SharePointFileViewState {
    const fileExtensionType = getFileTypeFromExtension(fileInformation.extension);
    const fileViewState: SharePointFileViewState = {
        fileExtensionType: fileExtensionType,
        id: fileInformation.id,
        downloadUrl: getFileDownloadUrl(fileInformation),
        groupSmtpAddress: fileInformation.groupSmtpAddress,
        retrievedTime: fileInformation.retrievedTime,
        strategy: null,
        url: fileInformation.url,
        thumbnailUrlTemplate: fileInformation.thumbnailUrlTemplate,
    };

    switch (fileExtensionType) {
        case FileExtensionTypes.Audio:
        case FileExtensionTypes.Pdf:
        case FileExtensionTypes.Video:
            fileViewState.strategy = {
                allowEdit: false,
                previewMethod: SharePointFilePreviewMethod.IFrame,
            };
            break;
        case FileExtensionTypes.Image:
            fileViewState.strategy = {
                allowEdit: false,
                previewMethod: SharePointFilePreviewMethod.Image,
            };
            break;
        case FileExtensionTypes.Text:
            fileViewState.strategy = {
                allowEdit: false,
                previewMethod: SharePointFilePreviewMethod.Text,
            };
            break;
        case FileExtensionTypes.Wac:
            fileViewState.strategy = {
                allowEdit: true,
                previewMethod: SharePointFilePreviewMethod.Wac,
            };
            break;
        case FileExtensionTypes.Others:
            return null;
    }

    return fileViewState;
}
